import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-571de27b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "QuotedDetail"
}
const _hoisted_2 = { class: "name1" }
const _hoisted_3 = { class: "user" }
const _hoisted_4 = { class: "info" }
const _hoisted_5 = { class: "name" }
const _hoisted_6 = { class: "report" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "举报", -1))
const _hoisted_8 = { class: "productInfo" }
const _hoisted_9 = { class: "infoItem" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "品种", -1))
const _hoisted_11 = { class: "value" }
const _hoisted_12 = { class: "infoItem" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "规格详情", -1))
const _hoisted_14 = { class: "value" }
const _hoisted_15 = { class: "infoItem" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "采购地", -1))
const _hoisted_17 = { class: "value" }
const _hoisted_18 = { class: "infoItem" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "更多说明", -1))
const _hoisted_20 = { class: "value" }
const _hoisted_21 = { class: "actions" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode("去报价")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("电话联系")
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "呼叫电话", -1))
const _hoisted_25 = { class: "telNum" }
const _hoisted_26 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VanImage = _resolveComponent("VanImage")!
  const _component_VanSwipeItem = _resolveComponent("VanSwipeItem")!
  const _component_VanSwipe = _resolveComponent("VanSwipe")!
  const _component_VanNoticeBar = _resolveComponent("VanNoticeBar")!
  const _component_VanButton = _resolveComponent("VanButton")!
  const _component_RestrictDialog = _resolveComponent("RestrictDialog")!
  const _component_VanPopup = _resolveComponent("VanPopup")!
  const _component_DataDoesNotExist = _resolveComponent("DataDoesNotExist")!

  return (Object.keys($setup.detail).length != 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_VanSwipe, {
          autoplay: 3000,
          "indicator-color": "white"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.images, (image) => {
              return (_openBlock(), _createBlock(_component_VanSwipeItem, {
                class: "my-swipe",
                key: image
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_VanImage, {
                    src: image.imageUrl,
                    alt: "图片",
                    width: "100%",
                    height: "100%",
                    onClick: ($event: any) => ($setup.jumpToUrl(image.linkUrl))
                  }, null, 8, ["src", "onClick"]),
                  _createElementVNode("div", _hoisted_2, _toDisplayString(image.shopName), 1)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }),
        _createVNode(_component_VanNoticeBar, {
          "left-icon": "volume-o",
          text: "",
          color: "red"
        }),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_VanImage, {
            src: $setup.detail.information.avatarUrl,
            alt: "图片",
            width: "3rem",
            height: "3rem",
            round: ""
          }, null, 8, ["src"]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString($setup.detail.information.nickName), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_VanButton, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.router.push({name:"Report",query:{id:$setup.route.query.id}}))),
              size: "small"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_VanImage, {
                  src: require('@/assets/img/jubao.png'),
                  alt: "图片",
                  width: "1rem",
                  height: "1rem"
                }, null, 8, ["src"]),
                _hoisted_7
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, _toDisplayString($setup.detail.categoryName), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, _toDisplayString($setup.detail.quantity || '若干') + _toDisplayString($setup.detail.quantity?$setup.detail.unit:''), 1)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, _toDisplayString($setup.detail.receiptAddress), 1)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, _toDisplayString($setup.detail.profile), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createVNode(_component_VanButton, {
            color: "#19be6b",
            block: "",
            onClick: $setup.toQuotedPrice
          }, {
            default: _withCtx(() => [
              _hoisted_22
            ]),
            _: 1
          }),
          _createVNode(_component_VanButton, {
            color: "#19be6b",
            block: "",
            onClick: $setup.getTel
          }, {
            default: _withCtx(() => [
              _hoisted_23
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_RestrictDialog, {
          modelValue: $setup.restrictShow,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.restrictShow) = $event)),
          code: $setup.restrictCode,
          type: "single"
        }, null, 8, ["modelValue", "code"]),
        _createVNode(_component_VanPopup, {
          class: "callDialog",
          show: $setup.isShowTel,
          "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => (($setup.isShowTel) = $event))
        }, {
          default: _withCtx(() => [
            _hoisted_24,
            _createElementVNode("div", _hoisted_25, "是否拨打 " + _toDisplayString($setup.tel), 1),
            _createElementVNode("a", {
              class: "call",
              href: `tel:${$setup.tel}`
            }, "立即呼叫", 8, _hoisted_26)
          ]),
          _: 1
        }, 8, ["show"]),
        _createVNode(_component_DataDoesNotExist, {
          modelValue: $setup.isDoesNotExist,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.isDoesNotExist) = $event))
        }, null, 8, ["modelValue"])
      ]))
    : _createCommentVNode("", true)
}